import { ApolloCache } from "@apollo/client";

export function clearTimelineQueryCache(cache: ApolloCache<any>) {
	cache.evict({ id: "ROOT_QUERY", fieldName: "timeline" });
}
